import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { ClientMfaCard } from '../components/portal/ClientMfaCard';
import { NotificationPrefs } from './ClientNotifications';

const Sessions = () => {
  const [rows, setRows] = useState(null);
  const load = () => api.get('/api/portal/sign-ins').then((r) => setRows(r.data.sign_ins)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const revokeAll = async () => {
    try { const { data } = await api.post('/api/auth/sessions/revoke-all'); toast.success(`Signed out of ${data.sessions_revoked} session(s)`); } catch { toast.error('Could not sign out other sessions'); }
  };
  return (
    <section className="rounded-xl border border-border bg-card p-4 space-y-2" data-testid="client-sessions">
      <h2 className="text-base md:text-lg font-semibold">Recent sign-ins</h2>
      {!rows ? <p className="text-sm text-muted-foreground">Loading…</p> : rows.length === 0 ? <p className="text-sm text-muted-foreground">No sign-ins recorded.</p> : (
        <ul className="text-sm space-y-1">{rows.map((s) => <li key={s.at}>{new Date(s.at).toLocaleString('en-AU')}{s.ip ? ` · ${s.ip}` : ''}</li>)}</ul>
      )}
      <Button variant="outline" size="sm" onClick={revokeAll} data-testid="client-signout-everywhere">Sign out everywhere</Button>
    </section>
  );
};

export default function MySettings() {
  return (
    <div className="p-4 sm:p-6 lg:p-10 space-y-6 max-w-3xl" data-testid="my-settings-page">
      <h1 className="text-4xl sm:text-5xl font-headings font-bold">Settings</h1>
      <section className="space-y-2"><h2 className="text-base md:text-lg font-semibold">Sign-in security</h2><ClientMfaCard /></section>
      <Sessions />
      <NotificationPrefs />
    </div>
  );
}
